import { Instance } from 'mobx-state-tree';
import { PlanningActionMetadataDrawRouteDtoModelBase } from './PlanningActionMetadataDrawRouteDtoModel.base';

/* The TypeScript type of an instance of PlanningActionMetadataDrawRouteDtoModel */
export interface PlanningActionMetadataDrawRouteDtoModelType extends Instance<typeof PlanningActionMetadataDrawRouteDtoModel.Type> {}

/* A graphql query fragment builders for PlanningActionMetadataDrawRouteDtoModel */
export { selectFromPlanningActionMetadataDrawRouteDto, planningActionMetadataDrawRouteDtoModelPrimitives, PlanningActionMetadataDrawRouteDtoModelSelector } from './PlanningActionMetadataDrawRouteDtoModel.base';

/**
 * PlanningActionMetadataDrawRouteDtoModel
 */
export const PlanningActionMetadataDrawRouteDtoModel = PlanningActionMetadataDrawRouteDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
